import { render } from "./ConfirmDialogue.vue?vue&type=template&id=ffad905c&scoped=true"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js"

import "./ConfirmDialogue.vue?vue&type=style&index=0&id=ffad905c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffad905c"]])

export default __exports__